/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   CarouselV3Controls.tsx
 */
import React, { Fragment } from 'react'

import { CarouselControlsProps } from '../types'

export const CarouselV3Controls = ({
  maxDots,
  isMobile,
  next,
  previous,
  goToSlide,
  carouselState,
  RightArrow,
  LeftArrow,
  ProgressDots,
  hideButtons,
}: CarouselControlsProps) => {
  const { totalItems, currentSlide } = carouselState

  return (
    <Fragment>
      {!isMobile && !hideButtons && (
        <LeftArrow
          currentSlide={currentSlide}
          goToSlide={goToSlide}
          previous={previous}
          totalItems={totalItems}
        />
      )}

      <ProgressDots
        currentSlide={currentSlide}
        goToSlide={goToSlide}
        isMobile={isMobile}
        maxDots={maxDots}
        totalItems={totalItems}
      />

      {!isMobile && !hideButtons && (
        <RightArrow
          currentSlide={currentSlide}
          goToSlide={goToSlide}
          next={next}
          totalItems={totalItems}
        />
      )}
    </Fragment>
  )
}
